import moment from 'moment-timezone';

export function localTime(time) {
  const getLocalTime = new Date(time);
  return getLocalTime;
}

export function localTimeZone() {
  const timeZone = moment.tz.guess();
  const zoneNameAbbr = moment.tz(timeZone).format('z');
  return zoneNameAbbr;
}
